export default __webpack_public_path__ + "static/media/seafood.189fa84f.svg";